import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  CdkDragDrop,
  CdkDropList,
  CdkDragPreview,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { SnapshotService } from '../Services/snapshot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { CustomsnapshotService } from '../Services/customsnapshot.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-snapshot-preview',
  templateUrl: './snapshot-preview.component.html',
  styleUrls: ['./snapshot-preview.component.scss']
})
export class SnapshotPreviewComponent implements OnInit {



  constructor(private renderer: Renderer2, private clientDetails: SnapshotSharedVariablesService,
    private cdref: ChangeDetectorRef,
    private snapShotService: SnapshotService, private _configCustomService: CustomsnapshotService,
    private routerObj: Router, private route: ActivatedRoute, private _configService: SnapshotService, private _loaderService: LoaderService) {

  }
  //constructor(private renderer: Renderer2,private _configCustomService:CustomsnapshotService, private snapShotService: SnapshotService, private routerObj: Router, private _configService: SnapshotService, private _loaderService: LoaderService) {

  //}
  @ViewChild("gridContainer") gridContainer: ElementRef | undefined;
  gridTempleteColumns: string = "";
  //totalNumberOfCharts: number = 0;
  totalNumberOfCharts: number = 0;
  //totalNumberOfCharts: number = 13;
  //columnPerRowCount: number = 2;
  columnPerRowCount: number = 0;
  isSubmitClicked: boolean = false;
  //columnPerRowCount: number = 4;
  showBackPopUp: boolean = false;
  ifCountMatched: boolean = false;
  widgetDetails: any;
  data: any = [];
  widgetList: any = [];
  datafromLayout: any;
  pagesConfiguredFromLayout: any;
  noOfWidgetConfigured: number = 0;
  layoutSubmitFlag: number = 0;
  clientSpecific: any;

  ngOnInit(): void {
    // code to handle the refresh
    const isParentChild = sessionStorage.getItem('isFromParent');
    const savedValue = sessionStorage.getItem('isRefresh');
    const navEntries = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    if (isParentChild == "true") {
      sessionStorage.setItem('isFromParent', 'false');
      sessionStorage.setItem('isRefresh', 'true');
      const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
      sessionStorage.setItem('dataToSend', JSON.stringify(dataToSend));
      sessionStorage.setItem('selectedSnapshotType', JSON.stringify(this._configCustomService.selectedSnapshotType));
      sessionStorage.setItem('selectedSection', this._configCustomService.selectedSection);
      sessionStorage.setItem('selectedSubsection', this._configCustomService.selectedSubsection);



      const navigation = this.routerObj.getCurrentNavigation();
      if (navigation?.extras.state) {
        const data = navigation.extras.state['data'];
        this.noOfWidgetConfigured = data?.widgetConfigured;
      } else {
        // Fallback to using history.state in case navigation is not available
        const data = history.state['data'];
        this.noOfWidgetConfigured = data?.widgetConfigured;
      }

      // Filter pages based on widget requirements with precise logic
      let filteredPageDetails = this.optimizePageLayout(
        this._configCustomService.dataFromPageDetailForPreview,
        this.noOfWidgetConfigured
      );

      // Validate and log the optimization results
      this.logOptimizationResults(
        this._configCustomService.dataFromPageDetailForPreview,
        filteredPageDetails,
        this.noOfWidgetConfigured
      );

      // Update service with optimized pages
      this._configCustomService.dataFromPageDetailForPreview = filteredPageDetails;

      let pages = [];
      for (let i = 0; i < filteredPageDetails.length; i++) {
        pages.push({
          page: filteredPageDetails[i].key,
          selectedLayout: filteredPageDetails[i].value, // Default value will be `null`
          disabled: false,
          dropdownOpen: false, // Add a flag to track dropdown state
          layout: [
            { label: 'Select a layout', value: null, selected: false },
            {
              label: '1 Widget Layout', value: 1, url: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_inactive.png",
              activeurl: "../../../../../assets/ImagesSnapshot/Public/SingleWidget_active.png", selected: filteredPageDetails[i].value == 1 ? true : false
            },
            {
              label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
              activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: filteredPageDetails[i].value == 4 ? true : false
            },
            {
              label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.svg",
              activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.svg", selected: filteredPageDetails[i].value == 6 ? true : false
            },
          ],
        });
      }
      this.datafromLayout = pages;



      if (this._configCustomService.layoutSubmitFlag == 1) {
        this.layoutSubmitFlag = 1;
      }
      // if (this._configCustomService.deleteWidgetFlag == 1) {
      //   this.layoutSubmitFlag = 1;
      // }
      //reveiving data from get call

      // if (this._configService.objectFromSnapshotLayout == "") {
      //   let pages = [];
      //   for (let i = 0; i < this._configCustomService.dataFromPageDetailForPreview.length; i++) {
      //     pages.push({
      //       page: this._configCustomService.dataFromPageDetailForPreview[i].key,
      //       selectedLayout: this._configCustomService.dataFromPageDetailForPreview[i].value, // Default value will be `null`
      //       disabled: false,
      //       dropdownOpen: false, // Add a flag to track dropdown state
      //       layout: [
      //         { label: 'Select a layout', value: null, selected: false },
      //         {
      //           label: '6 Widget Layout', value: 6, url: "../../../../../assets/ImagesSnapshot/Public/sixWidget_inactive.png",
      //           activeurl: "../../../../../assets/ImagesSnapshot/Public/sixWidget_active.png", selected: this._configCustomService.dataFromPageDetailForPreview[i].value == 6 ? true : false
      //         },
      //         {
      //           label: '4 Widget Layout', value: 4, url: "../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png",
      //           activeurl: "../../../../../assets/ImagesSnapshot/Public/fourWidget_active.png", selected: this._configCustomService.dataFromPageDetailForPreview[i].value == 4 ? true : false
      //         }
      //       ],
      //     });
      //   }
      //   this.datafromLayout = pages;

      // }
      // else { //receieving data from snapshot Layout
      //   this.datafromLayout = JSON.parse(this._configService.objectFromSnapshotLayout);
      //   this.layoutSubmitFlag = 1;
      // }

      let sum = 0;
      let count = 0;
      this.datafromLayout.forEach((val: any) => {
        if (val.selectedLayout != null) {
          sum = sum + val.selectedLayout;
          count++;
        }
      })
      console.log(sum)
      //If no. of pages configured in layout is only one then disable right pagination click
      if (count == 1) {
        this.disableRightClick = true;
      }
      //this.totalNumberOfCharts=this.snapShotService.LayoutDiv;
      this.pagesConfiguredFromLayout = count;
      this.totalNumberOfCharts = sum;
      this.columnPerRowCount = sum;

      var imgKeys = Object.keys(this._configCustomService.chartImagesPreviewList);
      var imgValues = Object.values(this._configCustomService.chartImagesPreviewList);


      // if (this.layoutSubmitFlag == 1) { //means data came after clicking submit on layout
      //   for (let i = 0; i < this.totalNumberOfCharts; i++) {
      //     this.chartList.push({
      //       widgetName: "",
      //       image: ""
      //     });
      //   }
      //   this.createInitialChartList();
      //   //Initially loading page 1 paginated divs
      //   this.data = this.paginatedData();
      //   if (this._configCustomService.widgetSaveObjectCustom.length > 0) {
      //     // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
      //     // this.widgetList = this._configService.processData(this.widgetDetails.WidgetDetail == undefined ? this.widgetDetails.WidgetDetail : this.widgetDetails.WidgetDetail);
      //     this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      //     this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustom[0], this._configCustomService.selectedSection, this._configCustomService.selectedSubsection == undefined ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name)

      //   }
      // }
      if (this._configCustomService.widgetSubmitObjectCustom.length > 0 && this.layoutSubmitFlag != 1) {

        //var x = this._configCustomService.widgetSubmitObjectCustom[0].snapshotType;
        var x = this._configCustomService.widgetSaveObjectCustomForPreview[0].snapshotType;

        var widgetDetail = [];
        for (let i = 0; i < x.length; i++) {
          if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
            for (let j = 0; j < x[i].section.length; j++) {
              if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
                for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                  if (x[i].section[j].subsection[k].subsection_name ===
                    ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                    widgetDetail = x[i].section[j].subsection[k].widget_detail;
                  }
                }
              }
            }
          }
        }

        for (let i = 0; i < this.totalNumberOfCharts; i++) {
          this.chartList.push({
            widgetName: "",
            image: ""
          });
        }

        for (let i = 0; i < widgetDetail.length; i++) {
          if (widgetDetail[i].previewChartPostion == 0) {
            continue;
          }
          // Cast as string if you are certain it is a string
          this.chartList[widgetDetail[i].previewChartPostion - 1].widgetName = widgetDetail[i].widget_name as string;

          for (let j = 0; j < imgKeys.length; j++) {
            if (widgetDetail[i].widgetchart_name === imgKeys[j]) {
              this.chartList[widgetDetail[i].previewChartPostion - 1].image = imgValues[j] as string;
            }
          }
        }

        if (this._configCustomService.widgetSubmitObjectCustom.length > 0) {
          // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
          // this.widgetList = this._configService.processData(this.widgetDetails.WidgetDetail == undefined ? this.widgetDetails.WidgetDetail : this.widgetDetails.WidgetDetail);

          this.widgetDetails = this._configCustomService.widgetSaveObjectCustomForPreview;
          //Handling multiple checkbox click scenario:------------------
          x = this.widgetDetails[0].snapshotType;
          let arr = [];
          for (let i = 0; i < x.length; i++) {
            if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
              for (let j = 0; j < x[i].section.length; j++) {
                if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
                  for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                    if (x[i].section[j].subsection[k].subsection_name ===
                      ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                      arr = x[i].section[j].subsection[k].widget_detail;
                      // for (let z = 0; z < x[i].section[j].subsection[k].widget_detail.length; z++) {
                      //   x[i].section[j].subsection[k].widget_detail[z].previewChartPostion=0;
                      // }
                    }
                  }
                }
              }
            }
          }
          //-------------------------------
          this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustomForPreview[0], this._configCustomService.selectedSection, (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name,this._configCustomService.audienceCohortType)
          let temp = this.widgetList;
          for (let i = 0; i < temp.length; i++) {
            temp[i].active = true;
          }
          for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < temp.length; j++) {
              if (arr[i].widget_name == temp[j].widgetName) {
                if (arr[i].previewChartPostion == 0) {
                  temp[j].active = false;
                }
              }
            }
          }
          this.widgetList = _.cloneDeep(temp);
          // // Trigger change detection
          // this.cdref.detectChanges();
          // this.widgetList = this.widgetList.map((widget:any) => ({ ...widget, active: true }));

        }

        this.createInitialChartList();
        this.data = this.paginatedData();
        this.CheckCountDropped();
      }
      else if (this._configCustomService.widgetSubmitObjectCustom.length == 0 && this.layoutSubmitFlag != 1 && this._configCustomService.widgetSaveObjectCustomForPreview.length > 0) { //if getting previously saved data

        var x = this._configCustomService.widgetSaveObjectCustomForPreview[0].snapshotType;
        var widgetDetail = [];
        for (let i = 0; i < x.length; i++) {
          if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
            for (let j = 0; j < x[i].section.length; j++) {
              if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
                for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                  if (x[i].section[j].subsection[k].subsection_name ===
                    ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                    widgetDetail = x[i].section[j].subsection[k].widget_detail;
                  }
                }
              }
            }
          }
        }

        for (let i = 0; i < this.totalNumberOfCharts; i++) {
          this.chartList.push({
            widgetName: "",
            image: ""
          });
        }

        for (let i = 0; i < widgetDetail.length; i++) {
          if (widgetDetail[i].previewChartPostion == 0) {
            continue;
          }
          this.chartList[widgetDetail[i].previewChartPostion - 1].widgetName = widgetDetail[i].widget_name as string;

          for (let j = 0; j < imgKeys.length; j++) {
            if (widgetDetail[i].widgetchart_name === imgKeys[j]) {
              this.chartList[widgetDetail[i].previewChartPostion - 1].image = imgValues[j] as string;
            }
          }
        }

        // Check if any object is filled
        const isAnyObjFilled = this.chartList.some((obj: any) => obj.image !== "" || obj.widgetName !== "");

        if (this._configCustomService.widgetSaveObjectCustomForPreview.length > 0) {
          // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
          // this.widgetList = this._configService.processData(this.widgetDetails.WidgetDetail == undefined ? this.widgetDetails.WidgetDetail : this.widgetDetails.WidgetDetail);
          this.widgetDetails = this._configCustomService.widgetSaveObjectCustomForPreview;

          //Handling multiple checkbox click scenario:------------------
          x = this.widgetDetails[0].snapshotType;
          let arr = [];
          for (let i = 0; i < x.length; i++) {
            if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
              for (let j = 0; j < x[i].section.length; j++) {
                if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
                  for (let k = 0; k < x[i].section[j].subsection.length; k++) {
                    if (x[i].section[j].subsection[k].subsection_name ===
                      ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                      arr = x[i].section[j].subsection[k].widget_detail;
                      // for (let z = 0; z < x[i].section[j].subsection[k].widget_detail.length; z++) {
                      //   x[i].section[j].subsection[k].widget_detail[z].previewChartPostion=0;
                      // }
                    }
                  }
                }
              }
            }
          }
          //-------------------------------

          this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustomForPreview[0], this._configCustomService.selectedSection, (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name,this._configCustomService.audienceCohortType)
          if (isAnyObjFilled) {
            let temp = this.widgetList;
            for (let i = 0; i < temp.length; i++) {
              temp[i].active = true;
            }
            for (let i = 0; i < arr.length; i++) {
              for (let j = 0; j < temp.length; j++) {
                if (arr[i].widget_name == temp[j].widgetName) {
                  if (arr[i].previewChartPostion == 0) {
                    temp[j].active = false;
                  }
                }
              }
            }
            this.widgetList = _.cloneDeep(temp);
            // // Trigger change detection
            // this.cdref.detectChanges();
            // this.widgetList = this.widgetList.map((widget:any) => ({ ...widget, active: true }));
          }

        }

        this.createInitialChartList();
        this.data = this.paginatedData();
        this.CheckCountDropped();
      }
      else { //for new user

        for (let i = 0; i < this.totalNumberOfCharts; i++) {
          this.chartList.push({
            widgetName: "",
            image: ""
          });
        }
        this.createInitialChartList();
        //Initially loading page 1 paginated divs
        this.data = this.paginatedData();
        if (this._configCustomService.widgetSaveObjectCustomForPreview.length > 0) {
          // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
          // this.widgetList = this._configService.processData(this.widgetDetails.WidgetDetail == undefined ? this.widgetDetails.WidgetDetail : this.widgetDetails.WidgetDetail);
          this.widgetDetails = this._configCustomService.widgetSaveObjectCustomForPreview;
          this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustomForPreview[0], this._configCustomService.selectedSection, (this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name,this._configCustomService.audienceCohortType)

        }
      }

      if (this._configCustomService.layoutSubmitFlag == 1) {
        this._configCustomService.layoutSubmitFlag = 0;
      }
      // if(this._configCustomService.deleteWidgetFlag==1){
      //   this._configCustomService.deleteWidgetFlag = 0;

      // }
      // Check if any object is filled
      const isAnyObjFilled = this.chartList.some((obj: any) => obj.image !== "" || obj.widgetName !== "");
      if (isAnyObjFilled == false) {
        this.ifCountMatched = false; //Making submit disable if chart list is empty
        this.isSubmitClicked = false;
      }
      //Initially making left click disable
      this.disableLeftClick = true;

      // if (localStorage.getItem('TotalwidgetDetailss')) {
      //    this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') ?? "");
      //    this.widgetList=this._configService.processData(this.widgetDetails.WidgetDetail == undefined ? this.widgetDetails.WidgetDetail : this.widgetDetails.WidgetDetail);
      // }

      // if (this._configCustomService.widgetSaveObjectCustomForPreview.length > 0) {
      //   // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
      //   // this.widgetList = this._configService.processData(this.widgetDetails.WidgetDetail == undefined ? this.widgetDetails.WidgetDetail : this.widgetDetails.WidgetDetail);
      //   this.widgetDetails = this._configCustomService.widgetSaveObjectCustomForPreview;
      //   this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustomForPreview[0], this._configCustomService.selectedSection, this._configCustomService.selectedSubsection == undefined ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name)

      // }
    }
    else if (savedValue == "true") {
      if (navEntries && navEntries.length > 0 && navEntries[0].type === 'reload') {
        sessionStorage.setItem('isRefresh', 'false');
        //this.router.navigate(['/Snapshot/configuaration']);
        this._configService.fromBackButton = false;
        this._configCustomService.fromBackButton = false;
        const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: false };
        let refreshData = JSON.parse(sessionStorage.getItem('dataToSend') || "{}");
        // this._configCustomService.selectedSnapshotType=JSON.parse(sessionStorage.getItem('selectedSnapshotType') || "{}");
        // this._configCustomService.selectedSection=sessionStorage.getItem('selectedSection');
        // this._configCustomService.selectedSubsection=sessionStorage.getItem('selectedSubsection');
        this._configCustomService.recievedStatusDataOnBackButtonClick = refreshData;
        this._configCustomService.recievedStatusDataOnBackButtonClick.fromBack = false;
        this._configService.ifDataExists = true;
        this.clientDetails.clientDetails = refreshData.clientDetails.clientDetails;
        this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: refreshData } });
      }
      else {
        console.log('Hi');
      }
    }
  }

  CheckCountDropped(param: string = 'dragging') {
    let dataObject = this._configService.clientSnapshotSelectedData;
    let number_of_widgets = dataObject?.number_of_widgets;
    const checkedIcons = document.getElementsByClassName('checked_icon');

    // if ((checkedIcons.length + 1) == number_of_widgets) {
    if (param == "dragging") {
      if ((checkedIcons.length + 1) == this.noOfWidgetConfigured) {
        this.ifCountMatched = true;
      } else {
        this.ifCountMatched = false;
        this.isSubmitClicked = false;
      }
    }
    else if (param == "deleting") {
      if ((checkedIcons.length - 1) == this.noOfWidgetConfigured) {
        this.ifCountMatched = true;
      } else {
        this.ifCountMatched = false;
        this.isSubmitClicked = false;
      }
    }


    // Optional: You can use the parameter inside the function if needed
    console.log(param);
  }


  // chartImagesPreviewList: any = {
  //   'Vertical Bar Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
  //   "Vertical Cluster Bar Chart": '',
  //   "Horizontal Bar Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
  //   "Horizontal Cluster Bar Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Clustered Bar.png',
  //   "AREA CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Area Chart.png',
  //   "LINE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Line chart.png',
  //   "Vertical Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Vertical lollipop Chart.png',
  //   "Horizontal Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal lollipop.png',
  //   "Cluster Lollipop Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Cluster lollipop.png',
  //   "01/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 01.png',
  //   "02/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 02.png',
  //   "03/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 03.png',
  //   "04/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 04.png',
  //   "05/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 05.png',
  //   "06/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 06.png',
  //   "07/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 07.png',
  //   "08/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 08.png',
  //   "09/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 09.png',
  //   "10/PIE CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Pie 10.png',
  //   'Scatter Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Scatter Chart.png',
  //   'Quadrant Scatter Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Scatter Chart.png',
  //   'Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Bubble Chart.png',
  //   'Quadrant Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Bubble Chart.png',
  //   "Vertical Stacked Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Vertical Stacked.png',
  //   "Horizontal Stacked Chart": 'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Stacked.png',
  //   "01/FUNNEL CHART": 'assets/ImagesSnapshot/ChartPreviewImages/Funnel Chart.png'
  // }


  // widgetListt = [
  //   {
  //     widgetName: "Trend of Metric 2",
  //     visualization: "Vertical Bar Chart",
  //     image: this.chartImagesPreviewList['Vertical Bar Chart'],
  //     active: false
  //   },
  //   {
  //     widgetName: "Brand Power Grid",
  //     visualization: "Bubble Chart",
  //     image: this.chartImagesPreviewList["Bubble Chart"],
  //     active: false
  //   },
  //   {
  //     widgetName: "Unaided awareness",
  //     visualization: "01/PIE CHART",
  //     image: this.chartImagesPreviewList["01/PIE CHART"],
  //     active: false
  //   },
  //   {
  //     widgetName: "Imagery Statements",
  //     visualization: "Horizontal Bar Chart",
  //     image: this.chartImagesPreviewList["Horizontal Bar Chart"],
  //     active: false
  //   },
  //   {
  //     widgetName: "Imagery Statements",
  //     visualization: "Horizontal Bar Chart",
  //     image: this.chartImagesPreviewList["Horizontal Bar Chart"],
  //     active: false
  //   }

  // ]

  // chartLists:any=[];
  chartList: {
    widgetName: string,
    image: string
  }[] = [];
  drop(event: CdkDragDrop<any>) {
    if (!this.gridContainer?.nativeElement.contains(event.event.target)) {
      return;
    }
    const targetElement = event.event.target as HTMLElement | null;
    if (targetElement && targetElement.tagName === 'IMG') {
      return;
    }
    if (targetElement && !targetElement.hasAttribute('grid_index')) {
      return;
    }
    let WidgetDetail = (event as any).detail;
    const gridIndex = (event.event.target as HTMLElement) != null ? Number((event.event.target as HTMLElement).getAttribute("grid_index")) : 0;
    const pageIndex = (event.event.target as HTMLElement) != null ? Number((event.event.target as HTMLElement).getAttribute("page_index")) : 0;
    // const finalIndex = (pageIndex - 1) * this.columnPerRowCount + gridIndex;
    let imgKeys = Object.keys(this._configCustomService.chartImagesPreviewList);
    let imgValues = Object.values(this._configCustomService.chartImagesPreviewList);
    for (let i = 0; i < imgKeys.length; i++) {
      if (WidgetDetail.visualization == imgKeys[i]) {
        WidgetDetail.image = imgValues[i];
      }
    }
    let temp = 0;
    // For the first page (page 0 or page 1), items always temp at index 0 and end at the number of items per page
    if (this.pageCount == 0 || this.pageCount==1) {
      temp = 0;
    }
    // For page numbers greater than 1,
    // calculate temp index based on previous pages' item counts
    if(this.pageCount>1)
    {
      for (let index = 0; index < this.datafromLayout.length; index++) {
         const pageNum = parseInt(this.datafromLayout[index].page.match(/\d+/)[0]);
          if (pageNum < this.pageCount) {
         temp = temp+this.datafromLayout[index].selectedLayout;
          }
      }
    }
    
    // Check if table widget can be added to the specific page layout
    if(WidgetDetail.visualization == "Table"){
       // Find the layout configuration for the page where the widget is being dropped
       let targetPageLayout = this.datafromLayout.find((layout: any) => {
         const pageNum = parseInt(layout.page.match(/\d+/)[0]);
         return pageNum === pageIndex;
       });
       
       // If the target page has more than 4 widgets, prevent table drop
       if(targetPageLayout && targetPageLayout.selectedLayout > 4){
          return;
       }
    }

    const finalIndex = temp + gridIndex;
    // Check if the target div already has an image
    if (this.chartList[finalIndex]?.image) {
      return; // Prevent drop if image already exists
    }
    this.chartList[finalIndex].widgetName = WidgetDetail.widgetName;
    this.chartList[finalIndex].image = WidgetDetail.image;
    WidgetDetail.active = true;

    this.CheckCountDropped();
    this.AddWidgetPositions(WidgetDetail.widgetName, finalIndex);
  }
  isChartDragged(WidgetDetail: any) {

    return WidgetDetail.widgetName == "";
  }
  getWidgetName(WidgetDetail: any) {
    return WidgetDetail.widgetName;
  }
  getWidgetImage(WidgetDetail: any) {
    return WidgetDetail.image;
  }
  removeWidgetFromGrid(WidgetDetail: any) {
    //for (let i = 0; i < this.widgetList.length; i++) {
    //    if (this.widgetList[i].widgetName === WidgetDetail.widgetName) {
    //    this.widgetList[i].active = false;
    //  break;  // Assuming widgetName is unique, exit the loop once found
    //}
    //}

    this.widgetList.filter((d: any) => d.widgetName == WidgetDetail.widgetName)[0].active = false;
    this.widgetList = this.widgetList;
    let widget = this.chartList.filter((d: any) => d.widgetName == WidgetDetail.widgetName)[0];
    widget.widgetName = "";
    widget.image = "";
    this.CheckCountDropped("deleting");
  }
  findClosestMultiple(number: number, base: number): number {
    const quotient = Math.ceil(number / base);
    return base * quotient;
  }

  //----------Handling pagination counter---------
  pageCount = 1;
  disableLeftClick = false;
  disableRightClick = false;
  Paginate(side: string) {
    if (side == 'left') {
      if (this.pageCount == 2) {
        this.pageCount--;
        this.createInitialChartList();
        this.data = this.paginatedData();
        this.disableLeftClick = true;
        this.disableRightClick = false;
        return;
      }
      else {
        this.disableLeftClick = false;
        this.disableRightClick = false;
        this.pageCount--;
        this.createInitialChartList();
        this.data = this.paginatedData();
      }
    }
    else if (side == 'right') {
      // if (this.pageCount == (Math.ceil(this.totalNumberOfCharts / this.columnPerRowCount) - 1)) {
      if (this.pageCount == (this.pagesConfiguredFromLayout - 1)) {

        //let x=Math.floor(this.totalNumberOfCharts/this.columnPerRowCount)-1;
        this.pageCount++;
        this.createInitialChartList();
        this.disableRightClick = true;
        this.data = this.paginatedData();
        this.disableLeftClick = false;
        return;
      }
      else {
        ;
        this.pageCount++;
        this.createInitialChartList();
        this.disableLeftClick = false;
        this.disableRightClick = false;
        this.data = this.paginatedData();
      }

    }
  }

  createInitialChartList() {
    // ;
    // for (let i = 0; i < this.totalNumberOfCharts; i++) {
    //   this.chartList.push({
    //     widgetName: "",
    //     image: ""
    //   });
    // }

    //Based on page number assign this.columnPerRowCount
    let page = this.datafromLayout.filter((item: any) => {
      return JSON.stringify(item).includes("Page " + this.pageCount)
    })
    this.columnPerRowCount = page[0].selectedLayout;

    this.gridTempleteColumns = "";
    for (let i = 0; i < (this.columnPerRowCount / 2); i++) {
      this.gridTempleteColumns += this.calculateValuePerDivision((this.columnPerRowCount / 2)) + "% ";
    }

  }
  calculateValuePerDivision(numDivs: any) {
    const k = 98; // considering for 2 always 27.5.So reciprocal method: 27.5=k/2=>55.
    //so now for 3 it will be 55/3 ,for 4 it will be 55/4 and so on....
    return k / numDivs;
  }

  paginatedData() {
    // Find how many items should be displayed per page
    let itemperPage=0
    for (let index = 0; index < this.datafromLayout.length; index++) {
         if(this.datafromLayout[index].page== "Page "+this.pageCount)
         {
          itemperPage=this.datafromLayout[index].selectedLayout;
         }
      }
    let start = 0;
    let end=0
    // For the first page (page 0 or page 1), items always start at index 0 and end at the number of items per page
    if (this.pageCount == 0 || this.pageCount==1) {
      start = 0;
      end=itemperPage;
    }
    // For page numbers greater than 1,
    // calculate start index based on previous pages' item counts
    if(this.pageCount>1)
    {
      for (let index = 0; index < this.datafromLayout.length; index++) {
         const pageNum = parseInt(this.datafromLayout[index].page.match(/\d+/)[0]);
          if (pageNum < this.pageCount) {
         start = start+this.datafromLayout[index].selectedLayout;
          }
      }
      end=start+itemperPage;
    }
    // const start = (this.pageCount - 1) * this.columnPerRowCount;
    // const end = start + this.columnPerRowCount;
    return this.chartList.slice(start, end);
  }
  // ----------------------------------------------------------------------------
  backButtonTitle = "WARNING!!";
  backButtonMessage = "Changes wont be saved if not submitted"
  confirmationPopup: boolean = false;
  goback() {
   if(!this.isSubmitClicked && this.ifCountMatched){
    this.showBackPopUp = true;
    this.confirmationPopup = true;
   }
   else{
     this.onProceedClick("");
   }

  }
  onCloseIconClick(data: any) {
    console.log("testing: ", data);
    this.showBackPopUp = false;
  }
  onProceedClick(data: any) {
    this.showBackPopUp = false;

    //for back button
    // this._configService.fromBackButton = true;
    // const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
    // this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
    // this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: dataToSend } });

    //for back button
    // this._configService.fromBackButton = true;
    this._configCustomService.backFromPreview = 1;
    // const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
    // this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
    // this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: dataToSend } });
    this._configService.fromBackButton = true;
    this._configCustomService.fromBackButton = true;
    const dataToSend = { clientDetails: this.clientDetails, enableWidgetLibrary: true, widgetObject: this._configService.ChartCustomSaveDataObject, fromBack: true };
    this._configCustomService.recievedStatusDataOnBackButtonClick = dataToSend;
    this.routerObj.navigate(['/Snapshot/configuaration'], { state: { data: dataToSend } });
  }

  showErrorPopUp = false;
  popUpMessage = "";
  errorheaderTitle = "";
  SubmitClicked() {
    this.isSubmitClicked = true;
    this._loaderService.showLoader();
    this._configService.WidgetLibSaveDataObject.isclientonSubmit = true;



    // this._configService.addSnapshotTypeWidgetDetails(this._configService.WidgetLibSaveDataObject).subscribe((data: any) => {
    //
    //   this._loaderService.hideLoader();
    // });

    //Submit the preview chart data to index
    this._configCustomService.widgetSubmitObjectCustom[0] = _.cloneDeep(this._configCustomService.widgetSaveObjectCustomForPreview[0]);
    this._configCustomService.widgetSubmitObjectCustom[0].IsclientonSubmit = true;


    var x = this._configCustomService.widgetSubmitObjectCustom[0].snapshotType;

    for (let i = 0; i < x.length; i++) {
      if (x[i].snapshotType_name === this._configCustomService.selectedSnapshotType.name) {
        for (let j = 0; j < x[i].section.length; j++) {
          if (x[i].section[j].section_name === this._configCustomService.selectedSection) {
            for (let k = 0; k < x[i].section[j].subsection.length; k++) {
              if (x[i].section[j].subsection[k].subsection_name ===
                ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection)) {
                for (let z = 0; z < x[i].section[j].subsection[k].widget_detail.length; z++) {
                  for (let l = 0; l < this.chartList.length; l++) {
                    if (this.chartList[l].widgetName == x[i].section[j].subsection[k].widget_detail[z].widget_name) {
                      x[i].section[j].subsection[k].widget_detail[z].previewChartPostion = l + 1;
                    }
                  }

                }
              }
            }
          }
        }
      }
    }

    // this._configCustomService.saveCustomSnapshotWidgetLibrary(this._configCustomService.widgetSubmitObjectCustom[0]).subscribe(
    //   (response: any) => {

    //     // response = JSON.parse(response.result);
    //     this._loaderService.hideLoader();
    //   }
    // );

    // this._configCustomService.widgetSaveObjectCustom= this._configCustomService.widgetSubmitObjectCustom;

    this._configCustomService.saveCustomSnapshotWidgetLibrary(this._configCustomService.widgetSubmitObjectCustom[0]).subscribe(
      (response: any) => {
        console.log('Response received:', response);
        // response = JSON.parse(response.result);
        if (response.Data == 'Document updated successfully') {
          // Handle success here
          this.showErrorPopUp = true;
          this.popUpMessage = "Saved Successfully.";
          this.errorheaderTitle = "Info";
          this._configCustomService.widgetSaveObjectCustom = this._configCustomService.widgetSubmitObjectCustom;

          this._loaderService.hideLoader();
          // this.fromSave = true;

        }
        else if (response.Data == 'Document inserted successfully') {
          this.showErrorPopUp = true;
          this.popUpMessage = "Saved Successfully.";
          this.errorheaderTitle = "Info";
          this._configCustomService.widgetSaveObjectCustom = this._configCustomService.widgetSubmitObjectCustom;

          this._loaderService.hideLoader();
          // this.fromSave = true;

        }
        else {
          // Handle any non-200 response codes
          this.showErrorPopUp = true;
          this.popUpMessage = "Some Error Occured";
          this.errorheaderTitle = "Info";
          this._loaderService.hideLoader();
          // this.fromSave = false;
        }
      }
    );

  }

  onCloseIconClickk(data: any) {
    this.showErrorPopUp = false;
    this.showBackPopUp = false;
  }

  AddWidgetPositions(widgetName: string, position: number) {
    // if (this._configCustomService.widgetSaveObjectCustom.length>0) {

    let a = this._configService.WidgetLibSaveDataObject?.WidgetDetail?.filter((m: any) => m.widget_name.toLowerCase() == widgetName.toLowerCase())[0];
    if (a != undefined) {
      a.previewChartPostion = position.toString();
    }
  }

  newListfromVisualSelect(data: any) {
    this.widgetList = data;
    //this.widgetDetails.WidgetDetail=this.widgetList;
  }

  // ----------------Adding Layout dropdown------------

  // openLayoutDropdown:boolean=false;
  // displayLayout="6 Widget Layout";
  // layoutValues:any = [
  //   { key: "6 Widget Layout", selected: true,num:6 },
  //   { key: "4 Widget Layout", selected: false,num:4}
  // ];
  // onLayoutClick(){
  //   this.openLayoutDropdown=!this.openLayoutDropdown;
  // }
  // layoutClicked(value:any){
  //   this.displayLayout=value.key;
  //   for(let i=0;i<this.layoutValues.length;i++){
  //     if(value.key==this.layoutValues[i].key){
  //       this.layoutValues[i].selected==true;
  //     }
  //     else{
  //       this.layoutValues[i].selected==false;
  //     }
  //   }


  //   //To show no.of grids as per layout selected
  //   this.columnPerRowCount = value.num;
  //   this.chartList=[];
  //   this.createInitialChartList();

  // }

  /**
   * Optimizes page layout by removing unnecessary pages based on precise widget count logic
   * @param pageDetails - Array of page objects with key and value properties
   * @param widgetCount - Number of widgets that need to be accommodated
   * @returns Optimized array of page details
   */
  optimizePageLayout(pageDetails: any[], widgetCount: number): any[] {
    console.log('=== PAGE OPTIMIZATION START ===');
    console.log('Input pages:', JSON.parse(JSON.stringify(pageDetails)));
    console.log('Widgets to accommodate:', widgetCount);

    // Validation checks
    if (!pageDetails || pageDetails.length === 0) {
      console.log('No pages provided, returning empty array');
      return [];
    }

    if (widgetCount <= 0) {
      console.log('No widgets to accommodate, returning first page only');
      return [pageDetails[0]];
    }

    // Sort pages by their natural order (Page 1, Page 2, etc.)
    const sortedPages = [...pageDetails].sort((a, b) => {
      const getPageNumber = (pageKey: string) => {
        const match = pageKey.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
      };
      return getPageNumber(a.key) - getPageNumber(b.key);
    });

    // // PRECISE LOGIC: Check for exact matches first
    // const exactMatchPage = sortedPages.find(page => (page.value || 0) === widgetCount);
    // if (exactMatchPage) {
    //   return [exactMatchPage];
    // }

    // PRECISE LOGIC: Find the smallest page that can accommodate all widgets
    const efficientPages = sortedPages
      .sort((a, b) => (a.value || 0) - (b.value || 0));

    if (efficientPages.length > 0) {
      return efficientPages;
    }

    // PRECISE LOGIC: Use minimum pages with optimal combination
    const optimalCombination = this.findMinimalPageCombination(sortedPages, widgetCount);



    return optimalCombination;
  }

  /**
   * Finds the minimal combination of pages needed to accommodate the target widgets
   * Uses a greedy approach optimized for real-world scenarios
   * @param pages - Available pages sorted by order
   * @param targetWidgets - Number of widgets to accommodate
   * @returns Minimal page combination
   */
  private findMinimalPageCombination(pages: any[], targetWidgets: number): any[] {
    // Strategy 1: Greedy approach - always pick the largest capacity that doesn't exceed remaining needs
    // let greedyResult = this.greedyPageSelection(pages, targetWidgets);

    // Strategy 2: Sequential approach - take pages in order until capacity is met
    let sequentialResult = this.sequentialPageSelection(pages, targetWidgets);

    // Return the approach that uses fewer pages
    const result = sequentialResult;


    return result;
  }

  /**
   * Greedy page selection - prioritizes larger pages first
   */
  private greedyPageSelection(pages: any[], targetWidgets: number): any[] {
    const sortedByCapacity = [...pages].sort((a, b) => (b.value || 0) - (a.value || 0));
    const selected = [];
    let remaining = targetWidgets;

    for (const page of sortedByCapacity) {
      if (remaining <= 0) break;

      const capacity = page.value || 0;
      if (capacity > 0) {
        selected.push(page);
        remaining -= capacity;
      }
    }

    // Sort back to natural order
    return selected.sort((a, b) => {
      const getPageNumber = (pageKey: string) => {
        const match = pageKey.match(/\d+/);
        return match ? parseInt(match[0]) : 0;
      };
      return getPageNumber(a.key) - getPageNumber(b.key);
    });
  }

  /**
   * Sequential page selection - takes pages in natural order
   */
  private sequentialPageSelection(pages: any[], targetWidgets: number): any[] {
    const selected = [];
    let remaining = targetWidgets;

    for (const page of pages) {
      if (remaining <= 0) break;

      const capacity = page.value || 0;
      selected.push(page);
      remaining -= capacity;
    }

    return selected;
  }

  /**
   * Logs optimization results for debugging and validation
   */
  private logOptimizationResults(originalPages: any[], optimizedPages: any[], widgetCount: number): void {
    console.log('📋 OPTIMIZATION SUMMARY:');
    console.log(`Original pages: ${originalPages.length}`);
    console.log(`Optimized pages: ${optimizedPages.length}`);
    console.log(`Pages removed: ${originalPages.length - optimizedPages.length}`);
    console.log(`Widget count: ${widgetCount}`);

    const originalCapacity = originalPages.reduce((sum, p) => sum + (p.value || 0), 0);
    const optimizedCapacity = optimizedPages.reduce((sum, p) => sum + (p.value || 0), 0);

    console.log(`Original total capacity: ${originalCapacity}`);
    console.log(`Optimized total capacity: ${optimizedCapacity}`);
    console.log(`Capacity efficiency: ${optimizedCapacity >= widgetCount ? '✅ Sufficient' : '❌ Insufficient'}`);

    if (optimizedPages.length < originalPages.length) {
      const removedPages = originalPages.filter(op =>
        !optimizedPages.some(np => np.key === op.key)
      );
      console.log(`Removed pages: ${removedPages.map(p => p.key).join(', ')}`);
    }

    console.log('📋 OPTIMIZATION SUMMARY END');
  }

}
